import React, { useState } from 'react';
import bellIcon from '../../../assets/images/campana.png';
import FarmacoModal from './FarmacoModal';
import '../../../styles/farmacovigilancia.css';

const PharmacovigilanceSection = () => {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <>
      <div className="pharmacovigilance-wrapper">
        <section className="pharmacovigilance-section">
          <div className="pharma-left">
            <img
              src={bellIcon}
              loading="lazy"
              alt="Campana"
              className="bell-icon"
            />
            <h1 className="pharma-title">
              Farma<span className="highlight">covigilancia</span>
            </h1>
          </div>
          <button
            className="report-button"
            onClick={() => setModalVisible(true)}
          >
            REPORTAR
          </button>
        </section>
      </div>
      <div className="pharma-white-line"></div>

      <FarmacoModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
      />
    </>
  );
};

export default PharmacovigilanceSection;
